import axiosReq from "utils/axiosConfig";
import { alertError, alertSuccess } from "./alert.service";

export const getEmployeeTypes = async ({ queryKey }) => {
  try {
  const { organizationId } = queryKey.length > 1 ? queryKey[1] : {};
    const res = await axiosReq.get(`/api/user/employeeTypes`, {
      params: {
        organizationId
      }
    });
    return res.data;
  } catch(err) {
    alertError(err.response?.data?.message ?? "");
  }
}

export const getEmployeeType = async ({ queryKey }) => {
  const { statusId } = queryKey.length > 1 ? queryKey[1] : {};
  try {
    const res = await axiosReq.get(`/api/user/employeeTypes/${statusId}`);
    return res.data;
  } catch(err) {
    alertError(err.response?.data?.message ?? "");
  }
}

export const createEmployeeType = async ({values}) => {
  try {
    const res = await axiosReq.post(`/api/user/employeeTypes/`, values);
    alertSuccess("Success");

    return res.data;
  } catch(err) {
    alertError(err.response?.data?.message ?? "");
  }
}

export const updateEmployeeType = async ({values, statusId}) => {
  try {
    const res = await axiosReq.put(`/api/user/employeeTypes/${statusId}`, values);
    alertSuccess("Success");

    return res.data;
  } catch(err) {
    alertError(err.response?.data?.message ?? "");
  }
}

export const deleteEmployeeType = async ({deleteId}) => {
  try {
    const res = await axiosReq.delete(`/api/user/employeeTypes/${deleteId}`);
    alertSuccess("Success");

    return res.data;
  } catch(err) {
    alertError(err.response?.data?.message ?? "");
  }
}